import { useLanguage } from "../lang/LanguageContext";
import Header from "../components/Header";

export default function Talks() {
  const { strings } = useLanguage();
  const talks = strings.expose.list;

  return (
    <main className="min-h-screen bg-white text-gray-900 font-sans mb-12">
      <Header />
      <div className="mt-12">
        <h1 className="text-3xl font-bold max-w-4xl mx-auto px-6 mb-8 text-center">
          {strings.expose.title}
        </h1>

        <div className="max-w-4xl mx-auto px-6 space-y-10">
          {talks.map((talk, index) => (
            <div
              key={index}
              className="grid grid-cols-1 md:grid-cols-[150px_1fr] gap-6"
            >
              {/* Date on the left OUTSIDE */}
              <div className="text-sm text-gray-500 font-medium pt-6">
                {talk.date}
              </div>

              {/* Card on the right */}
              <div className="bg-white border rounded-lg shadow hover:shadow-md transition p-6">
                <h2 className="text-xl font-semibold mb-1">{talk.title}</h2>
                <p className="text-gray-600 mb-2">
                  <span className="font-medium text-gray-800">
                    {talk.event}
                  </span>
                </p>
                <p className="text-gray-700 mb-4">{talk.description}</p>

                {talk.ressources && talk.ressources.length > 0 && (
                  <div className="flex flex-wrap gap-3">
                    {talk.ressources.map((res, resIndex) => (
                      <a
                        key={resIndex}
                        href={res.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-3 py-1 text-sm bg-blue-600 text-white rounded-full hover:bg-blue-700 transition"
                      >
                        {res.title}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
